export enum CUSTOM_REJECTION_REASON {
  multipleIssues = 'MULTIPLE_ISSUES',
  unknownIssue = 'UNKNOWN_ISSUE',
}
